export const SplitIcon = () => {
  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" fill="white" r="8.5" stroke="#BCB9BE" transform="rotate(-180 9 9)" />
      <path d="M10.5 12.3333L14.5 8.90468L10.5 5.47611" stroke="#BCB9BE" strokeLinecap="round" />
      <path d="M7.5 12.3333L3.5 8.90468L7.5 5.47611" stroke="#BCB9BE" strokeLinecap="round" />
    </svg>
  );
};
